import angular from 'angular';
import ManageSharedAssetsController from './manage/manage.shared.assets.controller';
import ManageSharedAssetsModalController from './manage/manage.shared.assets.modal.controller';
import ShareAssetsController from './share/share.assets.controller';

const sharingModule = angular
  .module('admin.assets.sharing', [
    'ui.bootstrap',
    'ui.router',
    'gettext'
  ])
  .controller('ManageSharedAssetsController', ManageSharedAssetsController)
  .controller('ManageSharedAssetsModalController', ManageSharedAssetsModalController)
  .controller('ShareAssetsController', ShareAssetsController);

export default sharingModule.name;